<template>
  <div class="author-profile">
    <img class="author-photo" :src="getSource(attributes.photo)" :alt="attributes.value" />
    <h2 class="author-name" v-markdown="attributes.value"></h2>
    <div class="author-jobtitle" v-markdown="attributes.jobtitle"></div>
  </div>
</template>

<script>
export default {
  props: ['attributes'],
  methods: {
    getSource (value) {
      if (!value) return null
      return require(`images/${value}`)
    }
  }
}
</script>

<style lang="scss">
.author-profile {
  .author-photo {
    display: block;
    width: 125px;
    height: 125px;
    background: $shadowColor;
    border-radius: 50%;
    margin: 0 auto;
  }
  .author-name {
    text-align: center;
    font-family: $font-SelaneForty;
    font-size: 25px;
    line-height: 30px;
  }
  .author-jobtitle {
    text-align: center;
    color: #727f8e;
    font-family: $font-SelaneForty;
    font-size: 20px;
    line-height: 24px;
  }
}
</style>